import type BaseError from '@/modules/errors/classes/BaseError.gen';
import {
  commonWretchErrorHandlerSugarMethods,
  type CommonWretchErrorHandlerMap,
  type CommonWretchErrorHandlerMapKey,
} from '@/modules/query-client/types/CommonWretchErrorHandlerMap';

const entriesTransform = ([k, v]: [
  string,
  new (originalError?: Error) => BaseError,
]) =>
  (commonWretchErrorHandlerSugarMethods as ReadonlyArray<string>).includes(k)
    ? [k, v]
    : [~~k, v];

type ObjectEntries = Record<
  CommonWretchErrorHandlerMapKey,
  new (originalError?: Error) => BaseError
>;
type ArrayEntries = Array<
  [CommonWretchErrorHandlerMapKey, new (originalError?: Error) => BaseError]
>;

/**
 * Create a new common wretch error handler map from an array.
 * @param entries - The entries array to create the map from.
 * @returns A new common wretch error handler map.
 */
export default function createCommonWretchErrorHandlerMap(
  entries: ObjectEntries
): CommonWretchErrorHandlerMap;
/**
 * Create a new common wretch error handler map from an object.
 * @param entries - The entries object to create the map from.
 * @returns A new common wretch error handler map.
 */
export default function createCommonWretchErrorHandlerMap(
  entries: ArrayEntries
): CommonWretchErrorHandlerMap;
/**
 * Create a new common wretch error handler map from an array or object.
 * @param entries - The entries array or object to create the map from.
 * @returns A new common wretch error handler map.
 */
export default function createCommonWretchErrorHandlerMap(
  entries: ObjectEntries | ArrayEntries
): CommonWretchErrorHandlerMap {
  return Array.isArray(entries)
    ? new Map(entries)
    : new Map(
        Object.entries(entries).map(entriesTransform) as Array<
          [
            CommonWretchErrorHandlerMapKey,
            new (originalError?: Error) => BaseError,
          ]
        >
      );
}
